import { createSlice } from "@reduxjs/toolkit";
import { deleteCustomer } from "../thunks/deleteCustomerThunk";

const deleteCustomerSlice = createSlice({
  name: "customerDelete",
  initialState: {
    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
    message: null,
  },
  reducers: {
    resetDeleteCustomerStatus: (state) => {
      state.status = "idle";
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteCustomer.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(deleteCustomer.fulfilled, (state, action) => {
        state.message = action.payload.msg;
        state.status = "success";
        state.error = null;
      })
      .addCase(deleteCustomer.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export const { resetDeleteCustomerStatus } = deleteCustomerSlice.actions;
export default deleteCustomerSlice.reducer;
